"use client";

import Script from "next/script";
import { useEffect, useState } from "react";
import { readConsent, CONSENT_EVENT } from "@/lib/consent";

const GTM_ID = process.env.NEXT_PUBLIC_GTM_ID;
// NIET OPNIEUW TOEVOEGEN: er stond hier een tweede container GTM-MPHTW35
// (env NEXT_PUBLIC_GTM_ID_2), verwijderd op 18-9-2026. Die container was niet
// van ons: 7 GA4-streams (waaronder G-HN6MZ3F0B9, die op onze pagina's
// meevuurde), 6 dode Universal Analytics-tags (UA-118666886-2/-4/-5,
// UA-38676921-23), Ads-conversie AW-949204775 die niet de onze is, en een
// verwijzing naar vendor veinteractive.com. Ons domein kwam er nergens in
// voor. Bezoekersdata ging er dus naar derden — AVG-risico.

/**
 * Google Tag Manager. AVG-veilig: laadt PAS na marketing-toestemming
 * (zelfde categorie als Meta Pixel, zie lib/consent.ts) — GTM is bedoeld als
 * centrale plek voor eventuele advertentie-/remarketingtags, dus behandelen
 * we 'm voorzichtiger dan de analytics-categorie. Trekt de bezoeker
 * toestemming in, dan stopt het laden bij de volgende paginaweergave.
 *
 * LET OP — live gecontroleerd 17-9-2026, de oude aanname hieronder was FOUT.
 * Het idee was dat GA4 (G-NQRP3XHSFY) en de Google Ads-conversie
 * (AW-767099873 / M_A_CMvc8JMBEOGH5O0C) als tags ín deze container zouden
 * zitten in plaats van rechtstreeks in de code. Dat is nooit afgemaakt:
 * GTM-M9M2CP7Z heeft wél de juiste triggers (page_view, view_item,
 * add_to_cart, begin_checkout, purchase) en twee "Google tag"-tags, maar in
 * de uitgeleverde gtm.js komt GEEN enkel meet- of conversie-ID voor — de
 * tags zijn dus niet aan een ID gekoppeld. Gevolg: G-NQRP3XHSFY ontvangt
 * nul hits, op geen enkele pagina. Fix hoort in de GTM-interface: koppel
 * G-NQRP3XHSFY aan de Google tag en AW-767099873 aan de conversietag.
 */
export default function GoogleTagManager() {
  const [allowed, setAllowed] = useState(false);

  useEffect(() => {
    const update = () => setAllowed(!!readConsent()?.marketing);
    update();
    window.addEventListener(CONSENT_EVENT, update);
    return () => window.removeEventListener(CONSENT_EVENT, update);
  }, []);

  if (!allowed) return null;

  return (
    <>
      {GTM_ID && (
        <>
          <Script id="gtm-init" strategy="afterInteractive">
            {`
              (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
              new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
              j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
              'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
              })(window,document,'script','dataLayer','${GTM_ID}');
            `}
          </Script>
          <noscript>
            <iframe
              src={`https://www.googletagmanager.com/ns.html?id=${GTM_ID}`}
              height="0"
              width="0"
              style={{ display: "none", visibility: "hidden" }}
              title="Google Tag Manager"
            />
          </noscript>
        </>
      )}
    </>
  );
}
